const initialState = {
    showOverlay: false,
    activePopup: null,
    popupData: {
        title: "",
        text: ""
    }
};

const PopupReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CLOSE_POPUP':
            return Object.assign({}, initialState);

        case 'OPEN_REGISTER_SUCCESS_POPUP':
            return Object.assign({}, state, {
                showOverlay: true,
                activePopup: 'RegisterSuccessPopup',
                popupData: initialState.popupData
            });

        case 'OPEN_SUCCESS_POPUP':
            return Object.assign({}, state, {
                showOverlay: true,
                activePopup: 'SuccessPopup',
                popupData: action.payload
            });

        case 'OPEN_FAIL_POPUP':
            return Object.assign({}, state, {
                showOverlay: true,
                activePopup: 'FailPopup',
                popupData: action.payload
            });

        case 'OPEN_FEEDBACK_POPUP':
            return Object.assign({}, state, {
                showOverlay: true,
                activePopup: 'FeedbackPopup',
                popupData: action.payload
            });

        default:
            return state;
    }
};

export default PopupReducer;


// WEBPACK FOOTER //
// ./src/reducers/Popup.js